// Varify.io custom-event goal names (must match the goals set up in Varify)
const VarifyEvents = Object.freeze({
  DetailsButton: 'details_button',
  SelectBuyButton: 'select_buy_button',
  CheckoutCompleted: 'checkout_completed',
});

export { VarifyEvents };
